import { Grid } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Colors } from "../../../theme/colors";
import { StyledCheckbox } from "../../form/checkbox";
import { StyledInput } from "../../form/input";
import { StyledTextarea } from "../../form/textarea";

export const EditProfileFormStep5: React.FC<Props> =
    ({
        handleChange,
        setFieldValue,
        values,
        errors,
        touched
    }) => {
        const { t } = useTranslation(['publisher', 'common']);

        return <>
            <Grid container direction="column">
                <StyledTitle>{t('editProfile.step5Title')}</StyledTitle>
                <Grid item container direction="row" spacing={2}>
                    <Grid item container sm={12} md={6} direction={'column'} spacing={2}>
                        <Grid item>
                            <StyledTextarea
                                id="description2"
                                label={t('editProfile.form.description2')}
                                onChange={handleChange}
                                value={values.description2}
                                rows={10}
                            />
                        </Grid>
                    </Grid>

                    <Grid item container sm={12} md={6} direction={'column'} spacing={2}>
                        <Grid item container direction={"column"} style={{ marginLeft: '1rem' }}>
                            <StyledSmallTitle>{t('editProfile.textServices.title')}</StyledSmallTitle>
                            <StyledCheckbox
                                id={"textService1"}
                                name={"textService1"}
                                onChange={handleChange}
                                value={values.textService1}
                                label={t('editProfile.textServices.option1')}
                            />
                            <StyledCheckbox
                                id={"textService2"}
                                name={"textService2"}
                                onChange={handleChange}
                                value={values.textService2}
                                label={t('editProfile.textServices.option2')}
                            />
                            <StyledCheckbox
                                id={"textService3"}
                                name={"textService3"}
                                onChange={handleChange}
                                value={values.textService3}
                                label={t('editProfile.textServices.option3')}
                            />
                            <StyledCheckbox
                                id={"textService4"}
                                name={"textService4"}
                                onChange={handleChange}
                                value={values.textService4}
                                label={t('editProfile.textServices.option4')}
                            />
                        </Grid>

                        <Grid item container direction={"column"} style={{ marginLeft: '1rem' }}>
                            <StyledSmallTitle>{t('editProfile.graphicServices.title')}</StyledSmallTitle>
                            <StyledCheckbox
                                id={"graphicService1"}
                                name={"graphicService1"}
                                onChange={handleChange}
                                value={values.graphicService1}
                                label={t('editProfile.graphicServices.option1')}
                            />
                            <StyledCheckbox
                                id={"graphicService2"}
                                name={"graphicService2"}
                                onChange={handleChange}
                                value={values.graphicService2}
                                label={t('editProfile.graphicServices.option2')}
                            />
                            <StyledCheckbox
                                id={"graphicService3"}
                                name={"graphicService3"}
                                onChange={handleChange}
                                value={values.graphicService3}
                                label={t('editProfile.graphicServices.option3')}
                            />
                        </Grid>

                        <Grid item container direction={"column"} style={{ marginLeft: '1rem' }}>
                            <StyledSmallTitle>{t('editProfile.otherServices.title')}</StyledSmallTitle>
                            <StyledCheckbox
                                id={"otherService1"}
                                name={"otherService1"}
                                onChange={handleChange}
                                value={values.otherService1}
                                label={t('editProfile.otherServices.option1')}
                            />
                            <StyledCheckbox
                                id={"otherService2"}
                                name={"otherService2"}
                                onChange={handleChange}
                                value={values.otherService2}
                                label={t('editProfile.otherServices.option2')}
                            />
                            <StyledCheckbox
                                id={"otherService3"}
                                name={"otherService3"}
                                onChange={handleChange}
                                value={values.otherService3}
                                label={t('editProfile.otherServices.option3')}
                            />
                            <Grid item container direction={"row"}>
                                <Grid item>
                                    <StyledCheckbox
                                        id={"otherService4"}
                                        name={"otherService4"}
                                        onChange={handleChange}
                                        value={values.otherService4}
                                        label={t('editProfile.otherServices.option4')}
                                    />
                                </Grid>

                                <StyledInputContainer item>
                                    <StyledInput
                                        id="otherService4text"
                                        label={""}
                                        onChange={handleChange}
                                        value={values.otherService4text}
                                    />
                                </StyledInputContainer>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>;
    }

interface Props {
    handleChange: any;
    setFieldValue: any;
    values: any;
    errors: any;
    touched: any;
}

const StyledTitle = styled('p')`
    color: ${Colors.lightViolet};
    font-size: 1.2rem;
    font-weight: 500;
    margin-left: 0.5rem;
`;

const StyledSmallTitle = styled('p')`
  color: ${Colors.lightViolet};
  font-size: 1rem;
  font-weight: 500;
`;

const StyledInputContainer = styled(Grid)`
  margin-left: 5px;
  flex: 1;
`;
